/**
 * Validates a name string using a regular expression.
 *
 * This function checks if the input name is a string, is not undefined or null,
 * is not empty, does not consist solely of spaces, and contains only letters and spaces.
 *
 * @function
 * @param {string} name - The name to validate.
 * @regex
 * - Ensure name is neither undefined nor null
 * - Ensure the input is a string
 * - Ensure the name is not an empty string
 * - Ensure the name is not made entirely of spaces
 * - Ensure the name contains only letters and spaces
 * @returns {boolean} A boolean value indicating whether the specified name is valid.
 */
export const validateName = (name) =>
  name !== undefined &&
  name !== null &&
  typeof name === "string" &&
  name !== "" &&
  !/^\s*$/.test(name) &&
  /^[A-Za-z ]+$/.test(name)
